<template>
  <div class="home">
    <landing-section></landing-section>
    <team-section></team-section>
    <projekt-section></projekt-section>
  </div>
</template>

<script>
import LandingSection from "@/components/Home/Landing.vue";
import TeamSection from "@/components/Home/TeamSection.vue";
import ProjektSection from "@/components/Home/ProjektSection.vue";

export default {
  title: "Ocular Collective - est. 2020 Bern",
  name: "Home",
  components: {
    LandingSection,
    TeamSection,
    ProjektSection,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
